<div class="cloud-tiles">
  <div class="cloud-tiles__inner">
    <div class="cloud-tiles__tile-wrapper">
      <div class="cloud-tiles__item" *ngFor="let block of block.content trackBy: trackByFn;">
        <div class="cloud-tiles__content-wrapper">
          <div class="cloud-tiles__content">
            <h2 class="cloud-tiles__content-header" [innerHTML]="block.data.header"></h2>
            <div class="cloud-tiles__content-text" [innerHTML]="block.data.content"></div>
            <script [src]="'https://fast.wistia.com/embed/medias/3rckh4rnv7.jsonp'" async></script>
            <a href="#" (click)="playVideo()" class="video-cta-wrapper__link">
              <button class="cloudacademy__btn">
                {{'Watch now' | translate}}
              </button>
            </a>
          </div>
        </div>
        <div class="cloud-tiles__image-wrapper">
          <div class="cloud-tiles__image-wrapper-wistia" [style.background-image]="parseImagePathURL(block.data.image)">
            <div
              [ngClass]="'wistia_embed wistia_async_3rckh4rnv7 popover=true popoverAnimateThumbnail=true popoverPreventScroll=true popoverContent=link'"
              style="display:inline;position:relative">
              <a href="#" class="video-cta-wrapper__imagelink">
                <img src="/assets/img/cloud-play-icon.svg" class="cloudacademy__btn-play" alt="Play button">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
